$(document).ready(function() {

  $('#emailModal form').ajaxForm(function(res) {
    alert(res);
  });

});